// extracted by mini-css-extract-plugin
export default {"error":"CompanyModal_error__Fj7nC"};